import { Base } from '@studiometa/js-toolkit';
import { Sentinel } from './Sentinel.js';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * Sticky component
 */
export default class Sticky extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Sticky',
    refs: ['target'],
    components: {
      Sentinel,
    },
  };

  /**
   * onSentinelIntersected
   * @param {*} entry
   */
  onSentinelIntersected({ args: [[entry]] }) {
    toggleClass(
      this.$refs.target,
      '!translate-y-4',
      entry.isIntersecting && entry.boundingClientRect.y < 0,
    );
  }
}
